import * as React from 'react';
import { FormControl, MenuItem, Select, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useHistory, useLocation } from 'react-router-dom';
import { ContextStore } from '../store/contextStore';
import { DRAWER_WIDTH } from './drawer';

const useStyles = makeStyles((theme) => ({
    root: {
        boxSizing: 'border-box',
        maxWidth: DRAWER_WIDTH,
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(0.5),
        paddingBottom: theme.spacing(0.5),
    },
    select: {
        fontSize: '0.8rem',
        '& .MuiSelect-select': {
            paddingTop: 4,
            paddingBottom: 4,
        },
    },
    label: {
        fontSize: '0.65rem',
        color: theme.palette.text.secondary,
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        marginBottom: 2,
    },
}));

const LicenseeSelector = ({ isDrawerOpen }) => {
    const classes = useStyles();
    const { isFranchise, licensees, userLicenseeIds, currentLicensee, setCurrentLicensee } = React.useContext(ContextStore);
    const history = useHistory();
    const location = useLocation();

    if (!isFranchise || !isDrawerOpen) {
        return null;
    }

    const handleLicenseeChange = (newLicensee) => {
        // If chat is currently open on a specific channel / conversation / screen, redirect to the
        // base /chat route before changing the licensee. The previous franchisee's channel IDs and
        // conversation unique-names are scoped to that franchisee's TO, so leaving the URL alone
        // would leave the ConversationsList / ChatScreen rendering stale data (or 404s) until the
        // user navigates away manually. The chat list at /chat refetches with the new
        // franchise_to and a fresh selection.
        if (newLicensee !== currentLicensee && location.pathname.startsWith('/chat/')) {
            history.push('/chat');
        }
        setCurrentLicensee(newLicensee);
    };

    // Single-licensee staff: show static text, no dropdown
    if (userLicenseeIds.length === 1) {
        const lic = licensees.find((l) => l.id === userLicenseeIds[0]);
        return (
            <div className={classes.root}>
                {/* <Typography className={classes.label}>Licensee</Typography> */}
                <Typography variant="body2" noWrap>{lic?.name || '—'}</Typography>
            </div>
        );
    }

    const showAll = userLicenseeIds.length > 1 || userLicenseeIds.length === 0;
    const visibleLicensees = licensees.filter(
        (l) => userLicenseeIds.length === 0 || userLicenseeIds.includes(l.id)
    );

    return (
        <div className={classes.root}>
            {/* <Typography className={classes.label}>Licensee</Typography> */}
            <FormControl fullWidth size="small">
                <Select
                    className={classes.select}
                    value={currentLicensee ?? ''}
                    onChange={(e) => handleLicenseeChange(e.target.value || null)}
                    displayEmpty
                    variant="outlined"
                    MenuProps={{ style: { zIndex: 99999 } }}
                >
                    {showAll && <MenuItem value="">All licensees</MenuItem>}
                    {visibleLicensees.map((l) => (
                        <MenuItem key={l.id} value={l.id}>{l.name}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
};

export default LicenseeSelector;
